import { request } from './client';
import { anonymousId } from '../state/anonymous';
import type { AppPlan } from '@/webapp/plan/planTypes';

/**
 * "Email me my app link" (reduce-friction handoff #2, owner 2026-10-08) — infra/lambda/shared/emailLink.ts.
 *
 * Signed out, while the app builds: the address gets a link at once and one reminder. The link
 * opens in whatever browser the email app picks — almost never the in-app browser the build began
 * in — so it is traded there for the build's choices (`openEmailLink`), and the ordinary sign-up
 * then collects the build as it would have here.
 */
export function emailMeTheLink(input: { email: string; requestKey: string; goal: string; appName: string; plan: AppPlan | null }): Promise<{ sent: true }> {
  return request<{ sent: true }>('/waiting/link', {
    base: 'api',
    method: 'POST',
    body: { ...input, anonId: anonymousId() },
  });
}

export interface OpenedLink {
  anonId: string;
  requestKey: string;
  goal: string;
  appName: string;
  plan: AppPlan | null;
  email: string;
  /** Still building, or built and held for whoever signs up. */
  state: 'running' | 'done';
  createdAt: string;
}

export function openEmailLink(token: string): Promise<OpenedLink> {
  return request<OpenedLink>('/waiting/open', { base: 'api', method: 'POST', body: { token } });
}
